export default "__VITE_ASSET__GrwVR4jO__"